export class CSPViolationLogger {
  static initialize() {
    document.addEventListener('securitypolicyviolation', (e) => {
      console.warn('CSP Violation:', {
        'violatedDirective': e.violatedDirective,
        'effectiveDirective': e.effectiveDirective,
        'blockedURI': e.blockedURI,
        'sourceFile': e.sourceFile,
        'lineNumber': e.lineNumber,
        'columnNumber': e.columnNumber,
        'statusCode': e.statusCode,
        'disposition': e.disposition
      });
    });
  }
}
